import Table from 'components/Table/TableStatic';
import {FC} from 'react';
import {t} from 'ttag';
import {jstDateTimeString} from 'utils/date';

import {SendingOrderItem} from '../types';

const Row: FC<SendingOrderItem> = ({
    client,
    dateTime,
    detailsDescription,
    detailsUrl,
    documentReminderDescription,
    sender,
    supersenditems,
}) => {
    const showDescription =
        !!detailsDescription || !!documentReminderDescription;

    return (
        <Table.Row>
            <Table.Cell className="break-words align-top">
                <div>{jstDateTimeString(dateTime)}</div>
                <div>
                    {supersenditems.map((item) => {
                        if (item.url) {
                            return (
                                <div key={item.mid}>
                                    <a href={item.url}>{item.label}</a>
                                </div>
                            );
                        } else {
                            return <div key={item.mid}>{item.label}</div>;
                        }
                    })}
                    {showDescription && (
                        <div className="mt-2 flex flex-col gap-1 text-light-secondary">
                            {detailsDescription && (
                                <div>{detailsDescription}</div>
                            )}
                            {documentReminderDescription && (
                                <div>{documentReminderDescription}</div>
                            )}
                        </div>
                    )}
                </div>
            </Table.Cell>
            <Table.Cell className="break-words align-top">{sender}</Table.Cell>
            <Table.Cell className="min-w-40 max-w-48 break-words align-top">
                {client}
            </Table.Cell>
            <Table.Cell className="text-right align-top">
                <a href={detailsUrl}>{t`View details`}</a>
            </Table.Cell>
        </Table.Row>
    );
};
export default Row;
